export default __webpack_public_path__ + "static/Bottom-Slant-fixed-bd15eaed0a5ee38ce77b24331ef1c918.png";